import zeusSdk from '_/utils/SDKs';

/**
 * Retry a destination push
 */
export const retryDestinationPushRequest = async (destinationPushId: string): Promise<void> => {
  await zeusSdk.destinationPushes.retry(destinationPushId);
};

/**
 * Revert a destination push
 */
export const revertDestinationPushRequest = async (destinationPushId: string): Promise<void> => {
  await zeusSdk.destinationPushes.revert(destinationPushId);
};
